import CV from "../Images/MY CV_page-0001.jpg";
import Navbar from "./Header";
import "../CSS/Resume.css";

function Resume() {
  return (
    <div className="resume">
      <Navbar />
      <h3>Resume</h3>
      <div className="img">
        <img src={CV} />
      </div>
    </div>
  );
}
export default Resume;
